// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"713":"98f25b8d","3352":"f8ca88b4","3690":"e5ed626e","3814":"253ab0be","4924":"b1c5ae78","5006":"d8dfc671","7153":"0ca1dfbe","7642":"87ba0472"}[chunkId] + ".js";
};